import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks/useUniversalNavContext';
import { getServerUrl } from '../../universal-nav/utils/getServerUrl';
import { footerV3FallbackData } from '../components/fallbackData';
export const useQueryFooterData = () => {
    const { sessionData, currentAccountId, bffHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['getFooter'],
        queryFn: async () => {
            var _a;
            const serverUrl = getServerUrl(bffHostname);
            const footerEndpoint = `${serverUrl}/api/v3/navigation-data/footer`;
            const response = await fetch(footerEndpoint, {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
                headers: {
                    'x-current-account-id': (currentAccountId === null || currentAccountId === void 0 ? void 0 : currentAccountId.toString()) || '',
                    'x-customuser-id': ((_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.customUserId) === null || _a === void 0 ? void 0 : _a.toString()) || '',
                },
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const currencyJson = await response.json();
            return currencyJson.data;
        },
        placeholderData: footerV3FallbackData,
    });
    const data = result.isLoading || result.isError ? footerV3FallbackData : result.data;
    return Object.assign(Object.assign({}, result), { data });
};
//# sourceMappingURL=useQueryFooterData.js.map
// @zapier/universal-layout@12.1.15 (040754877)
